import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';
import { listPositions } from '../../../services/careers/careersService';
import type { Position } from '../../../services/careers/types';

export default function CareersRoles() {
  const { t } = useTranslation();
  const [positions, setPositions] = useState<Position[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    listPositions().then(result => { if (active) setPositions(result.positions); }).catch(() => { if (active) setError(true); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);
  if (loading) return <p role="status" className="mt-9">{t('common.loading')}</p>;
  if (error) return <div role="alert" className="mt-9"><p>{t('hiring.errors.REQUEST_FAILED')}</p><button className="mt-3 min-h-[44px] underline" onClick={() => setAttempt(value => value + 1)}>{t('hiring.retry')}</button></div>;
  if (!positions.length) return <p className="mt-9">{t('hiring.noRoles')}</p>;
  return <div className="mt-9 grid gap-5 sm:grid-cols-2 sm:gap-6">{positions.map(position => <article key={position.id} className="flex flex-col items-start rounded-2xl border border-slate-200 bg-slate-50/60 p-6 dark:border-slate-700 dark:bg-slate-800/40 sm:p-8">
    <span className="mb-5 rounded-full bg-emerald-100 px-3 py-1 text-sm text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-200">{t(position.accepting_applications ? 'hiring.open' : 'hiring.closed')}</span>
    <h3 lang="en" className="mb-3 text-2xl font-semibold">{position.content.en.title}</h3>
    <p lang="en" className="mb-7 flex-1 leading-7 text-secondary dark:text-secondary-dark">{position.content.en.summary}</p>
    <Link to={`/careers/${position.slug}`} className="inline-flex min-h-[44px] items-center gap-2 font-semibold text-emerald-700 dark:text-emerald-300">{t('hiring.viewRole')}<ArrowUpRight size={18} aria-hidden="true" /></Link>
  </article>)}</div>;
}
